// Consent popups (card activation, batch card order, admin consent, ...) open a window.open() tab,
// send the cardholder/admin through a cross-origin Palary consent page, and get redirected back to
// our own consent-callback route. That route relays a "consent finished" signal to the opener over
// this BroadcastChannel and closes its own tab — see pages/callbacks/consent and the use*Consent hooks.
//
// Reveal popups (show card number, show PIN) share the same BroadcastChannel protocol below, but
// their endpoints don't accept a redirectURL — the popup never lands back on our origin, so they
// don't need an entry in CONSENT_POPUP_WINDOW_NAMES (nothing to protect AuthInitializer from there).

// Shared across every popup flow above, consent or reveal alike.
export const CONSENT_POPUP_PROTOCOL = {
	CHANNEL: 'consent_popup_channel',
	MESSAGE_TYPE: 'CONSENT_POPUP_DONE',
	// localStorage key carrying a per-flow nonce from the opener to the callback (shared same-origin
	// storage, so it needs no query param on the allow-listed redirect URL). The callback echoes the
	// nonce in its message and the opener only settles on a match — so a stray same-origin callback
	// visit can't settle an unrelated flow.
	NONCE_KEY: 'consent_popup_nonce',
	// localStorage key carrying the app path the flow started from (e.g. the company debit-card page).
	// If the callback can't close its own tab, it sends the user back there instead of to HOME.
	RETURN_PATH_KEY: 'consent_popup_return_path',
};

// window.open names for flows that redirect the popup back to our own origin — persist across the
// cross-origin navigation, so the callback route (and AuthInitializer) can recognise it is running
// inside a throwaway consent popup.
export const CONSENT_POPUP_WINDOW_NAME = {
	ACTIVATION: 'card-activation',
	BATCH_ORDER: 'debit-cards-batch-order',
	ADD_ADMIN: 'add-company-admin',
};

export const CONSENT_POPUP_WINDOW_NAMES = Object.values(CONSENT_POPUP_WINDOW_NAME);

// window.open names for flows that never redirect back to our own origin — no AuthInitializer risk,
// so these intentionally don't appear in CONSENT_POPUP_WINDOW_NAMES.
export const REVEAL_POPUP_WINDOW_NAME = {
	SHOW_CARD_NUMBER: 'show-card-number',
	SHOW_PIN: 'show-pin',
};
